import { Component, Input, ViewChild } from '@angular/core';

import { MdSidenav, MdSidenavToggleResult } from '@angular/material';
export class TdLayoutComponent {

   sidenav: MdSidenav;
/**
 * Proxy toggle method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public toggle(): Promise<MdSidenavToggleResult> {
    return this.sidenav.toggle();
  }
/**
 * Proxy open method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public open(): Promise<MdSidenavToggleResult> {
    return this.sidenav.open();
  }
/**
 * Proxy close method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public close(): Promise<MdSidenavToggleResult> {
    return this.sidenav.close();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-layout',
  styleUrls: ['./layout.component.css' ],
  templateUrl: './layout.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sidenav': [{ type: ViewChild, args: [MdSidenav, ] },],
};
}

function TdLayoutComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdLayoutComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdLayoutComponent.ctorParameters;
/** @type {?} */
TdLayoutComponent.propDecorators;
/** @type {?} */
TdLayoutComponent.prototype.sidenav;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
